angular.module('ihestiaSsoBase.constants', []);
